import ContactForm from './ContactForm';

interface FeaturesProps {
  onOpenContactForm: () => void;
}

export default function Features({ onOpenContactForm }: FeaturesProps) {
  return (
    <section id="features" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">こんなお悩みございませんか?</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            医学情報に精通したサーチャーが文献を調査・検索し、<br />
            <span className="text-[#eb4b3f] font-semibold">リストにしてご提供</span>します
          </p>
        </div>

        <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-3xl p-8 md:p-12 mb-16 shadow-2xl">
          <div className="space-y-4 text-white">
            <div className="flex items-start gap-3">
              <i className="ri-question-line text-2xl text-[#f0945b] mt-1"></i>
              <p className="text-lg">お目当ての論文の見つけ方・探し方がわからない…</p>
            </div>
            <div className="flex items-start gap-3">
              <i className="ri-question-line text-2xl text-[#f0945b] mt-1"></i>
              <p className="text-lg">検索してみたけど、ぴったりな文献が見つからない…</p>
            </div>
            <div className="flex items-start gap-3">
              <i className="ri-question-line text-2xl text-[#f0945b] mt-1"></i>
              <p className="text-lg">忙しくて、論文検索や文献選定にあてる時間がない…</p>
            </div>
          </div>
        </div>

        <div className="text-center mb-12">
          <div className="flex flex-col items-center justify-center gap-4">
            <button
              onClick={onOpenContactForm}
              className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-[#eb4b3f] to-[#f0945b] text-white text-base font-semibold rounded-full hover:from-[#d43d31] hover:to-[#e08549] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-right-circle-line mr-2 text-xl"></i>
              キーワード検索を利用する
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
